<div
  class="row"
  style="padding-left: 10px; padding-bottom: 6px; margin-top: -60px"
>
  <div class="col-md-8">
    <span class="welcomeText">Welcome</span><br />
    <span class="searchResultName">{{ fullName | uppercase }}</span
    ><br />
    <span class="labelCommon">Checked-In Location: </span>
    <span class="staticText">{{
      cardholderDetails?.identity.currentShip.shipName
    }}</span>
  </div>
  <div class="col-md-4">
    <br /><br />
    <a
      class="float-right"
      style="font-weight: bold; color: #337ab7; margin-right: 25px"
      [routerLink]="['/help']"
      fragment="_Toc202836362"
      ><span class="icon-NC_alert"></span>&nbsp;Report Card Lost or Stolen</a
    >
  </div>
</div>
<div
  class="row"
  style="padding-left: 10px"
  *ngIf="hasEntitlement('CARDHOLDERACCTS_ACCOUNTS')"
>
  <div
    class="card-nc col-md-5"
    style="background-color: #ffffff; padding-bottom: 6px; margin-right: 30px"
  >
    <div class="row">
      <div class="col-md-5">
        <span class="labelCommon">CHIP ACCOUNT</span><br />
        <span *ngIf="selectedChipAccount" class="staticText1">{{
          selectedChipAccount?.account
        }}</span>
      </div>
      <div class="col-md-4" style="padding-right: 0px; padding-left: 0px">
        <span class="labelCommon">ACCOUNT BALANCE</span><br />
        <span class="staticText1"
          ><span class="dollerSymbolColor"></span
          >{{ selectedChipAccount?.currentBalance | currency }}</span
        >
      </div>
      <div class="col-md-3" style="padding-right: 0px; padding-left: 0px">
        <span class="labelCommon">STATUS</span><br />
        <span class="staticText1" *ngIf="selectedChipAccount"
          >{{ selectedChipAccount?.status }} &nbsp;<i
            [ngClass]="selectedChipAccount?.status | processingStatusPipe"
          ></i
        ></span>
      </div>
    </div>
  </div>
  <div
    class="col-md-1"
    style="
      margin-left: -40px;
      margin-right: -6px;
      padding-right: 0px;
      padding-left: 0px;
    "
  >
    &nbsp;
  </div>
  <div
    class="card-nc col-md-6"
    style="background-color: #ffffff; padding-bottom: 6px"
  >
    <div class="row">
      <div class="col-md-5">
        <span class="labelCommon">STRIP ACCOUNT</span><br />
        <span class="staticText1">{{ stripAccount?.account }}</span>
      </div>
      <div class="col-md-4" style="padding-right: 0px; padding-left: 0px">
        <span class="labelCommon">ACCOUNT BALANCE</span><br />
        <span class="staticText1"
          ><span class="dollerSymbolColor"></span
          >{{ stripAccount?.currentBalance | currency }}</span
        >
      </div>
      <div class="col-md-3" style="padding-right: 0px; padding-left: 0px">
        <span class="labelCommon">STATUS</span><br />
        <span class="staticText1"
          >{{ stripAccount?.status }} &nbsp;<i
            [ngClass]="stripAccount?.status | processingStatusPipe"
          ></i
        ></span>
      </div>
    </div>
  </div>
</div>
<div
  class="row"
  style="padding-left: 10px; margin-top: 15px; margin-right: 0px"
  *ngIf="
    cardholderDetails &&
    cardholderDetails.linkedAccount &&
    hasEntitlement('CARDHOLDERACCTS_ACCOUNTS')
  "
>
  <div
    class="col-md-12 zeroPadding card card-nc"
    style="background-color: #ffffff"
  >
    <div class="card-heading">
      <i class="fa fa-link"></i
      ><span class="cardHeaderHeading"> LINKED BANK ACCOUNT </span>
    </div>
    <div class="card-body">
      <div
        class="row chipRowBackground labelCommon text-nowrap"
        style="margin-top: -15px; padding-top: 10px; padding-bottom: 5px"
      >
        <div class="col-md-2 zeroPadding col-centered accountBorder m-0">
          <div class="col-md-12">ACH Allowed</div>
          <div class="col-md-12 staticText1">
            {{ cardholderDetails.achAllowed }}
          </div>
        </div>
        <div class="col-md-2 zeroPadding col-centered accountBorder m-0">
          <div class="col-md-12">Name on Account</div>
          <div class="col-md-12 staticText1">
            {{ cardholderDetails?.linkedAccount?.srcAcctName }}
          </div>
        </div>
        <div class="col-md-2 zeroPadding col-centered accountBorder m-0">
          <div class="col-md-12">Routing Number</div>
          <div class="col-md-12 staticText1">
            {{ cardholderDetails?.linkedAccount?.srcABANum }}
          </div>
        </div>
        <div class="col-md-2 zeroPadding col-centered accountBorder m-0">
          <div class="col-md-12">Bank Account Number</div>
          <div class="col-md-12 staticText1">
            *****{{ cardholderDetails?.linkedAccount?.srcAcctNum }}
          </div>
        </div>
        <div class="col-md-2 zeroPadding col-centered m-0">
          <div class="col-md-12">Account Type</div>
          <div
            class="form-group col-md-12"
            [ngSwitch]="cardholderDetails.linkedAccount.srcORGType"
          >
            <div *ngSwitchCase="'C'" class="staticText1">Checking</div>
            <div *ngSwitchCase="'B'" class="staticText1">Business</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-container *ngIf="hasEntitlement('CARDHOLDERACCTS_ACCOUNTS')">
  <div class="row" style="padding-left: 10px; margin-right: 0px">
    <div
      class="col-md-12 zeroPadding card card-nc"
      style="margin-top: 15px"
      *ngFor="let card of cardholderDetails?.cardList"
    >
      <!-- Default card contents -->
      <div class="card-heading">
        <i class="fa fa-cc-mastercard"></i
        ><span class="cardHeaderHeading"> ACCOUNT INFORMATION </span>
      </div>
      <div class="card-body">
        <div class="row cardHoldersRowBackground labelCommon text-nowrap">
          <div class="col-md-2 zeroPadding col-centered accountBorder m-0">
            <div class="col-md-12">Card Number</div>
            <div class="col-md-12 staticText1">*****{{ card.masterCard }}</div>
          </div>
          <div class="col-md-2 zeroPadding col-centered accountBorder m-0">
            <div class="col-md-12">Issue Date</div>
            <div class="col-md-12 staticText1">
              {{ card.issueDate | date: "MM/dd/yyyy" }}
            </div>
          </div>
          <div class="col-md-2 zeroPadding col-centered accountBorder m-0">
            <div class="col-md-12">Expiry Date</div>
            <div class="col-md-12 staticText1">
              {{ card.expirationDate | date: "MM/dd/yyyy" : "UTC" }}
            </div>
          </div>
          <div class="col-md-2 zeroPadding col-centered accountBorder m-0">
            <div class="col-md-12">Card Status Date</div>
            <div class="col-md-12 staticText1">
              {{ card.statusDate | date: "MM/dd/yyyy" }}
            </div>
          </div>
          <div class="col-md-2 zeroPadding col-centered m-0">
            <div class="row">
              <div class="col-md-12">Card Status</div>
              <div class="form-group col-md-12 staticText1">
                {{ card.status }}
              </div>
            </div>
          </div>
          <div class="col-md-2" style="margin-top: 17px">
            <p [ngClass]="card.status | processingStatusPipe"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
